<template>
    <div class="col-sm-6">
        <div class="card root">
            <div class="card-header text-white bg-dark">
                Card
            </div>

            <div v-if="card != null" v-show="!editing" class="card-body">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <div class="input-group-text">{{ card.brand }}</div>
                    </div>
                    <input
                        v-model="card_number"
                        type="text"
                        class="form-control text-center"
                        placeholder="•••• •••• •••• ••••"
                        disabled
                    />
                    <div class="input-group-append">
                        <div class="input-group-text">
                            {{ card.month }} / {{ card.year }}
                        </div>
                    </div>
                </div>
            </div>

            <div v-show="editing" id="stripe_card" class="card-body" />

            <div class="card-footer text-right">
                <button
                    v-if="!editing"
                    class="btn btn-danger text-white"
                    @click="editing = true"
                >
                    Change Card
                </button>

                <button
                    v-if="editing"
                    :disabled="loading"
                    class="btn btn-secondary text-white"
                    @click="editing = false"
                >
                    Cancel
                </button>
                <button
                    v-if="editing"
                    :disabled="loading"
                    class="btn btn-dark text-white btn-margin"
                    @click="createCardToken"
                >
                    Submit
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import superagent from 'superagent'

import { config, auth, gateway, response } from 'website-core'

export default {
    data() {
        return {
            card: null,

            stripe_card: null,
            stripe_selector: '#stripe_card',

            editing: false,
            loading: false,
        }
    },
    computed: {
        card_number() {
            if (!this.card) {
                return ''
            }

            return '•••• •••• •••• ' + this.card.last4
        },
    },
    created() {
        this.getCustomer()
    },
    mounted() {
        gateway.stripe.init()
        this.stripe_card = gateway.stripe.initCard(this.stripe_selector)
    },
    methods: {
        getGateway(gateways) {
            for (var gateway in gateways) {
                return gateway
            }
            return
        },
        getCustomer() {
            var self = this

            superagent
                .get(config.url_api + '/customer')
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200 || !res.body) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.customer = res.body

                    var gateway_type = self.getGateway(self.customer.gateway)
                    if (!gateway_type) {
                        return ''
                    }

                    self.card = self.customer.gateway[gateway_type].card
                    return
                })
        },
        async createCardToken() {
            this.loading = true
            console.log(this.stripe_card)

            const { token, err } = await gateway.stripe.createCardToken(
                this.stripe_card
            )
            console.log(token)
            console.log(err)
            if (err) {
                this.loading = false
                response.ResShowErr(err)
                return
            }

            this.changeCard(token)
        },
        changeCard(token) {
            var self = this

            self.loading = true
            superagent
                .put(config.url_api + '/customer/card')
                .type('form')
                .query(auth.getAuthQs())
                .send({ card_token: token })
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200 || !res.body) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.card = res.body
                    response.ResShowOK('')
                    self.editing = false
                    return
                })
        },
    },
}
</script>

<style scoped>
.root {
    margin: 0.5rem 0;
}

.billing {
    margin: 1rem 0;
}

#stripe_card {
    margin: 1rem 1.3rem;
}

.StripeElement {
    background-color: white;
    padding: 8px 12px;
    border-radius: 0.25rem;
    border: 1px solid rgba(0, 0, 0, 0.125);
}

.StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
    border-color: #fa755a;
}

.StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
}
</style>
